export type Notification = {
  id: string
  notification_type: NotificationType
  user_id: string
  message: string
  read_at: string | null
  created_at: string
  notification_context?: NotificationContext
}

export type NotificationContext =
  | ModelNotificationContext
  | FileUploadNotificationContext

export type ModelNotificationContext = {
  appId: string
}

export type FileUploadNotificationContext = {
  appId: string
  modelId: string
}

export enum NotificationType {
  FILE_ACTION = 1,
  MODEL_TRAINING = 2,
  MODEL_TRAININGS_PER_MONTH_EXCEEDED = 3,
  MODEL_TEST_DATA_PER_MONTH_EXCEEDED = 4,
  DATASET_STORAGE_LIMIT_EXCEEDED = 5,
  EVENT_STORAGE_LIMIT_EXCEEDED = 6
}
